import { render, staticRenderFns } from "./travel1.vue?vue&type=template&id=80d79506&scoped=true&"
import script from "./travel1.vue?vue&type=script&lang=js&"
export * from "./travel1.vue?vue&type=script&lang=js&"
import style0 from "./travel1.vue?vue&type=style&index=0&id=80d79506&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d79506",
  null
  
)

export default component.exports